import { Height } from "@mui/icons-material";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons.jsx";
import { alignItems, height } from "@mui/system";

export default {
    row1: [
        {
            column: "column1",
            columnWidth: "50%",
            rows: {
                row1: [
                    {
                        name: "Principla Place Of Business",
                        component: "header",
                    },
                ],

                row2: [
                    {
                        name: "address",
                        actionText: "Address",
                        component: "textarea",
                        width: "100%"
                    },
                ],


                row6: [
                    {
                        name: "kycAddressCountry",
                        label: "Country",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getCountry"
                    },
                ],


                row7: [
                    {
                        name: "kycAddresscity",
                        label: "City",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getCityMaster"
                    },
                    {
                        name: "kycAddresspostalcode",
                        label: "Postal Code",
                        component: "text-field",
                    },
                ],
                row8: [
                    {
                        name: "kycAddressTelephone",
                        label: "Telephone",
                        component: "text-field",
                    },
                    {
                        name: "kycAddressmobioeno",
                        label: "Mobile",
                        component: "text-field",
                    },
                ],
                row9: [
                    {
                        name: "kycAddressfax",
                        label: "Fax",
                        component: "text-field",
                    },
                    {
                        name: "kycAddressEmail",
                        label: "Email",
                        component: "text-field",
                    },
                ],
                row10: [
                    {
                        name: "kycAddresssameas",
                        label: "Mailing Address",
                        checkboxLabel: "Same as Principal Place of Business",
                        component: "checkboxbox",
                    },
                ],
                row11: [
                    {
                        name: "KycAddressName",
                        label: "Name",
                        component: "text-field",
                    },
                ],
                row12: [
                    {
                        name: "kddresses",
                        actionText: "Address",
                        component: "textarea",
                        width: "100%"
                    },
                ],

                row15: [
                    {
                        name: "kycsameasAddressCountry",
                        label: "Country",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getCountry"
                    },
                    {
                        name: "kycsameaspostalcode",
                        label: "Postal Code",
                        component: "text-field",
                    },
                ],


                row16: [
                    {
                        name: "kycsameascity",
                        label: "City",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getCityMaster"
                    },
                    {
                        name: "kycsameasstate",
                        label: "State",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getStateMaster"
                    },

                ],
                row17: [
                    {
                        name: "kycsameasTelephone",
                        label: "Telephone",
                        component: "text-field",
                    },
                    {
                        name: "kycsameasmobioeno",
                        label: "Mobile",
                        component: "text-field",
                    },
                ],
                row18: [
                    {
                        name: "kycsameasfax",
                        label: "Fax",
                        component: "text-field",
                    },
                    {
                        name: "kycsameasEmail",
                        label: "Email",
                        component: "text-field",
                    },
                ],
            }
        }
    ]
}